module.exports = __webpack_public_path__ + "img/usb_12_24_front.b6913b9c.png";